import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Box, Container, Typography, useTheme } from '@mui/material';
import { COLOR_DENIM, COLOR_CHATHAMS_BLUE, COLOR_WHITE } from 'popTheme';
import { PopAppBarLoginOnly } from 'components/appBar/PopAppBar';
import backgroundImage from 'components/landing/background.svg';
import { Footer } from 'components/landing/Collaborators';
import { useNavigate } from 'react-router-dom';

export const InvalidToken = () => {
  const theme = useTheme();
  const intl = useIntl();
  const navigate = useNavigate();

  const messages = defineMessages({
    resetPasswordExpired: {
      id: 'resetPassword.expired.text',
      defaultMessage: 'Link you followed has expired.',
      description: 'Reset password expired email link',
    },
    resetPasswordExpiredRedirect: {
      id: 'resetPassword.expired.redirect.text',
      defaultMessage: 'You will be directed to the login page shortly.',
      description: 'Expired email link redirect message',
    },
  });

  const REDIRECT_PAUSE_TIME = 10000; // 10 seconds

  useEffect(() => {
    setTimeout(() => {
      navigate('/signin');
    }, REDIRECT_PAUSE_TIME);
  });

  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        height: '100%',
      }}
    >
      <Box xs={2} pt="3.75rem" sx={{ px: { xs: '1.5rem', sm: '3.75rem' } }}>
        <PopAppBarLoginOnly />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        paddingBottom="3rem"
        width="100%"
        height="100vh"
      >
        <Box width="360px" alignSelf="flex-start" marginTop="3rem">
          <Container
            sx={{
              bgcolor: COLOR_DENIM,
              color: 'white',
              height: '100%',
              borderRadius: '0.75rem',
              py: '2rem',
              [theme.breakpoints.only('xs')]: {
                my: '1rem',
              },
            }}
          >
            <Typography variant="h4" textAlign="center" color={COLOR_WHITE} mb={'0.5rem'}>
              {intl.formatMessage(messages.resetPasswordExpired)}
            </Typography>
            <Typography
              variant="subtitle1"
              color={COLOR_WHITE}
              mt={'1rem'}
              lineHeight={'1.21874rem'}
              align={'center'}
            >
              {intl.formatMessage(messages.resetPasswordExpiredRedirect)}
            </Typography>
          </Container>
        </Box>
      </Box>
      <Box
        xs={3}
        justifyContent="space-evenly"
        sx={{
          color: COLOR_CHATHAMS_BLUE,
          [theme.breakpoints.up('sm')]: {
            justifyContent: 'normal',
          },
        }}
      >
        <Footer />
      </Box>
    </Box>
  );
};
